// src/pages/PaymentSuccess.tsx

import { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetBillingOverviewQuery } from "@/store/rest_api";
import React from "react";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const { refetch } = useGetBillingOverviewQuery();

  const paymentIntentId = searchParams.get("payment_intent");
  const paymentIntentClientSecret = searchParams.get("payment_intent_client_secret");

  useEffect(() => {
    const timer = setTimeout(async () => {
      await refetch();
      setVerifying(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [refetch]);

  return (
    <div className="container mx-auto p-6 flex items-center justify-center min-h-[60vh]">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          {verifying ? (
            <>
              <Loader2 className="h-16 w-16 mx-auto mb-4 animate-spin text-primary" />
              <CardTitle>Processing Payment</CardTitle>
              <CardDescription>Please wait while we confirm your payment...</CardDescription>
            </>
          ) : (
            <>
              <CheckCircle2 className="h-16 w-16 mx-auto mb-4 text-green-500" />
              <CardTitle>Payment Successful!</CardTitle>
              <CardDescription>Your credits have been added to your account</CardDescription>
            </>
          )}
        </CardHeader>
        <CardContent className="space-y-4">
          {!verifying && (
            <>
              {paymentIntentId && (
                <div className="bg-muted p-3 rounded-lg">
                  <p className="text-xs text-muted-foreground">Transaction ID</p>
                  <p className="text-sm font-mono">{paymentIntentId}</p>
                </div>
              )}
              <div className="flex gap-2">
                <Button onClick={() => navigate("/manage-organisation/billing/overview")} className="flex-1">
                  View Balance
                </Button>
                <Button
                  onClick={() => navigate("/manage-organisation/billing/transactions")}
                  variant="outline"
                  className="flex-1"
                >
                  View Transactions
                </Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
